import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';

import { Alert, Chip, Snackbar } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Seo } from 'src/components/seo';
import { therapistBulkSignature } from 'src/config';
import useCurrentUser from 'src/hooks/use-current-user';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { useSettings } from 'src/hooks/use-settings';
import {
  getAllDocumentationOverview,
  getAllTaskOverview,
  getAllTherapyOverview,
  getDashboardSupervisorEditAction,
  getTherapistDailyUpdatesAction,
  getTimeCheckInAction,
} from 'src/redux/actions/therapist-dashboard-action';
import { getClockInOutButtonVisibility } from 'src/redux/actions/facilityActions';
import ThoughtSpotIntegration from 'src/sections/department-dashboard/ThoughtspotIntegration';
import {
  convertDateToFacilityDate,
  convertIntoIsoFormat,
} from 'src/utils/convertDateToSelectedTimeZone';
import NewSlickSlider from './new-slider';
import { TaskStatus } from './task-overview/task-status';
import DocumentManagement from './therapist-document/document-manegment';
import MySignatureManagement from './therapist-document/therapist-bulk-signature/my-signature-management';
import OtherSignatureDocument from './therapist-document/therapist-bulk-signature/other-signature-document';
import TimeInTimeOut from './time-in-out/time-in-time-out';
import TodaysOverview from './todays-activity/todays-overview';

const Page = () => {
  const settings = useSettings();
  const dispatch = useDispatch();
  const [isTherapistBulkSignature] = useFeatureToggleWhenReady(
    therapistBulkSignature,
    'ENTERPRISE'
  );

  let realm = '';
  if (window.location.hostname === 'localhost') {
    realm = localStorage.getItem('realm') || '';
  } else {
    realm = window.location.hostname.split('-')[0] || '';
  }
  const [providerId] = useCurrentUser(['providerId']);
  const facilityId = localStorage.getItem('facilityId');
  const therapistDailyUpdatesCount = useSelector(
    (state: any) => state.dashboardSupervisorEditReducer.response?.data?.length || 0
  );

  // APIT-587: fetch the per-facility Clock In/Out flag ONCE on dashboard load.
  // The three flag-consumers on this page (button + document/signature sections)
  // read the resulting redux value; document operations refetch on demand.
  useEffect(() => {
    dispatch(getClockInOutButtonVisibility());
  }, [dispatch]);

  useEffect(() => {
    const currentDate = new Date();
    const dateTimeAccordingToFacility = convertDateToFacilityDate(currentDate);
    const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
    const formattedDate = moment(currentDate).format('YYYY-MM-DD');
    const isClockIn = localStorage.getItem('isCheckIn') === 'true' ? true : false;
    if (providerId) {
      dispatch(
        getAllTaskOverview({
          providerId,
          date: formattedDate,
          facilityId,
        })
      );
      dispatch(
        getAllTherapyOverview({
          providerId,
          date: formattedDate,
          facilityId,
        })
      );
      dispatch(
        getAllDocumentationOverview({
          providerId,
          date: formattedDate,
          facilityId,
        })
      );
      if (!isClockIn) {
        dispatch(
          getTimeCheckInAction({
            providerId,
            date: convertIntoIsoFormat(dateTimeAccordingToFacility),
            zoneTime: getFacilityTimeZone,
          })
        );
      }
    }
  }, [providerId]);

  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState('');

  const getResponseOfCheckout = useSelector((state: any) => state.checkoutReducer);

  useEffect(() => {
    if (getResponseOfCheckout?.isGetCheckIn === false && getResponseOfCheckout?.response !== null) {
      setSnackBarMsg(getResponseOfCheckout?.response?.message);
      setOpenSnackBar(true);

      return;
    }
  }, [getResponseOfCheckout]);

  const handleCloseSnackBar = () => {
    setSnackBarMsg('');
    setOpenSnackBar(false);
  };

    useEffect(() => {
      if (providerId) {
        dispatch(
          getTherapistDailyUpdatesAction({
            currentDate: moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM-DD'),
            providerId: providerId,
          })
        );
        dispatch(getDashboardSupervisorEditAction());
      }
    }, [providerId, dispatch]);
  return (
    <>
      <Seo title="Restore-Insights: Dashboard" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // py: 8,
          py: 3,
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          <Grid
            container
            disableEqualOverflow
            spacing={{
              xs: 3,
              lg: 4,
            }}
          >
            <Grid xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                spacing={4}
              >
                <div
                  style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '8px' }}
                >
                  <Typography variant="h4">
                    My Day
                    {/* {greeting || ''}, {user?.firstName || ''} */}
                  </Typography>
                  <Typography
                    sx={{ color: '#6C737F' }}
                    variant="body2"
                  >
                    Manage your goals, tasks and activities for today
                  </Typography>
                </div>

                <TimeInTimeOut />
              </Stack>
            </Grid>
            <Grid
              xs={12}
              md={12}
              container
              mb={'30px'}
            >
              <Grid
                md={12}
                lg={4.5}
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  gap={'10px'}
                  mb={'10px'}
                >
                  <Typography variant="h6">Daily Updates</Typography>
                  <Chip
                    label={`${therapistDailyUpdatesCount} Updates`}
                    variant="outlined"
                    sx={{ height: '25px', marginLeft: '5px', border: '1px solid #afb3ba9e' }}
                  />
                </Box>
                <Box
                  sx={{
                    height: '280px',
                    borderRadius: '18px',
                    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <NewSlickSlider />
                </Box>
              </Grid>
              <Grid
                md={12}
                lg={7.5}
              >
                <Typography
                  variant="h6"
                  mb={'10px'}
                >
                  Daily Overview
                </Typography>
                <TaskStatus />
              </Grid>
            </Grid>

            <Grid xs={12}>
              <TodaysOverview />
            </Grid>
            <Grid
              xs={12}
              md={12}
            >
              <DocumentManagement />
            </Grid>

            {isTherapistBulkSignature ? (
              <>
                <Grid
                  xs={12}
                  md={12}
                >
                  <MySignatureManagement />
                </Grid>
                <Grid
                  xs={12}
                  md={12}
                >
                  <OtherSignatureDocument />
                </Grid>
              </>
            ) : null}

            {/* <Grid
              xs={12}
              md={4}
            >
              <AcademyDailyProgress />
            </Grid> */}
          </Grid>
          <Grid
            style={{ marginTop: '20px', marginBottom: '20px' }}
            xs={12}
            md={12}
          >
            {/* <NewUpdates /> */}
            {/* <AcademyDailyProgress /> */}
            {realm && <ThoughtSpotIntegration who="therapist" />}
          </Grid>
        </Container>
        <Snackbar
          onClose={handleCloseSnackBar}
          autoHideDuration={2000}
          open={openSnackBar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackBarMsg}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default Page;
